import React, {useState, useEffect} from "react";
// import PerformanceTable from "../components/PerformanceTable";
import MyPageCompanyCard from "../components/MyPageCompanyCard";
import MainTable from "../components/MainTable";
import config from "../config/config";
const API_URL = config.API_URL;

function ManagerMypageCompanyManage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setSelectedRow(null);
    setIsModalOpen(false)
  };
  const handleOverlayClick = (e)=>{
    if(e.target === e.currentTarget){
      closeModal();
    }
  }

  // ESC 키로 모달 닫기
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        closeModal();
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, []);

  //Header 작성부분`
  useEffect(() => {
    const eventHandler = () => {
      console.log(`🟣 [mypage] newBoardEntry_mypage 감지됨!`);
      handleNewEntry();
    };

    window.addEventListener(`newMypageEntry_ManagerManage`, eventHandler);
    return () => {
      console.log("⚪ [Mypage] 이벤트 리스너 제거됨");
      window.removeEventListener(`newMypageEntry_ManagerManage`, eventHandler);
    };
  }, []);

  const handleNewEntry = () => {
    // console.log("handle new Entry 실행됨");
    window.open("https://4yiv226334kpzbeeindx2uagui0ljbbq.lambda-url.ap-northeast-2.on.aws/", "_blank", "noopener,noreferrer");
  };

  // API 호출 함수
  const fetchData = async () => {
    try {
      const response = await fetch(`${API_URL}/api/incubator/getCompanyList`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include"
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      // console.log(result.value);

      if (result.result) {
        // 데이터를 변환하여 company -> startup_name 매핑
        const formattedData = result.value.map((row, index) => ({
          _id: row.startup_id || index + 1, // ID 설정
          company: row.name || '-',
          businesstype : row.company_type || '-',
          owner: row.owner || "-", 
          contact: row.contact || '-',
          address: row.address || '-',
          homeSite : row.homepage || '-',
          industryType: row.industry_type || "-", // 날짜만 추출
          estabDate: row.establishment_date ? row.establishment_date.split("T")[0] : "-", // 날짜만 추출,
        }));
        setData(formattedData);
      } else {
        console.error("데이터 가져오기 실패:", result.message);
      }
    } catch (error) {
      console.error("Error fetching startup data:", error);
      // setError(error.message); // 에러 메시지 저장
    } finally {
      setLoading(false); // 데이터 로딩 완료
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const headTitles = [
    { key: 'id', label: '순번', searchable: false },
    { key: 'company', label: '입주사명' },
    { key: 'businesstype', label: '사업자형태'},
    { key: 'owner', label: '대표자' },
    { key: 'contact', label: '연락처' },
    { key: 'address', label: '주소' },
    { key: 'homeSite', label: '홈페이지'},
    { key: 'industryType', label: '업종' },
    { key: 'estabDate', label: '설립일'},
  ];
 
  const actionMenuItems = [
  ];

  const handleActionMenuClick = async (key, rowId) => {
    setSelectedRow(rowId);
    // console.log(rowId);
    openModal();
  };

  return(
    <div>
      {loading ? (
        <p>Loading...</p>
      ):(
        <>
          <MainTable title="입주기업 관리카드" tableHeadTitles={headTitles} tableData={data} 
            pageType={"mypage"}
            onActionMenuClick={handleActionMenuClick} actionMenuItems={actionMenuItems} mainSearchKey="company"/>
          {isModalOpen && <div style={styles.overlay} onClick={handleOverlayClick}>
            <div style={styles.container}>
              <MyPageCompanyCard 
                style={styles.body}
                modal={true}
                onClose={closeModal}
                startupId={selectedRow}/>
            </div>
          </div>}
        </>
      )}
    </div>
  ); 
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)", // 반투명 배경
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  container: {
    display:"flex",
    flexDirection: "column",
    gap:"24px",
    width: "1185px",
    height: "850px",
    overflowY: 'auto',
    boxSizing: "border-box",
    position: "relative",
    backgroundColor: "white",
    borderRadius :"25px"
  },
  titleSection: {
    display:"flex",
    alignItems: "center",
    justifyContent: "space-between"
  },  
  body:{
    display:"flex",
    flexDirection:"column",
    gap:"16px"
  },
  xBox:{
    display:"flex",
    alignItems:"center",
    justifyContent: "center",
    cursor:"pointer",
    width: "20px",
    height:"20px"
  }
}

export default ManagerMypageCompanyManage;